'use client';

import React, { ReactNode } from 'react';
import { loadStripe, Stripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

let stripePromise: Promise<Stripe | null>;

const getStripe = () => {
  if (!stripePromise) {
    const publishableKey = process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY;
    
    if (!publishableKey) {
      console.warn('NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY is not set');
      return Promise.resolve(null);
    }
    
    stripePromise = loadStripe(publishableKey);
  }
  return stripePromise;
};

export const StripeProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  // Use the promise directly - Elements can accept a Promise<Stripe>
  const stripePromise = React.useMemo(() => getStripe(), []);

  return (
    <Elements stripe={stripePromise}>
      {children}
    </Elements>
  );
};

export { getStripe };
